import React from "react"
import { Box, Card, Typography, useMediaQuery, useTheme } from "@mui/material"
import { useNavigate } from "react-router-dom"
import { logisticaItems } from "./logisticaNav"

const styles = {
    containerButtons: {
        display: "flex",
        justifyContent: "center",
        gap: 3,
        flexWrap: "wrap"
    },
    containerButtonsMobile: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 3
    }
}

const softColors = ["#3598DC", "#E7505A", "#8E44AD", "#32C5D2", "#C49F47"]

export default function LogisticaHome({ items = logisticaItems }) {
    const navigate = useNavigate()
    const theme = useTheme()
    const mobile = useMediaQuery(theme.breakpoints.down("md"))

    return (
        <Box p={2}>
            <Box sx={mobile ? styles.containerButtonsMobile : styles.containerButtons}>
                {items.map((item, index) => (
                    <Box key={item.path} sx={{ width: mobile ? "100%" : "20%" }}>
                        <Card
                            onClick={() => navigate(`/${item.path}`)}
                            sx={{
                                padding: 5,
                                cursor: "pointer",
                                borderRadius: 3,
                                backgroundColor: softColors[index % softColors.length],
                                transition: "background-color 0.3s ease-in-out",
                                "&:hover": {
                                    backgroundColor: "#aaa"
                                }
                            }}
                        >
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                }}
                            >
                                <Typography variant="h6" color="white" position="absolute">
                                    {item.description}
                                </Typography>
                                <Box display="flex" justifyContent="center">
                                    {React.cloneElement(item.icon, {
                                        style: { color: "white", opacity: "20%", fontSize: 100 }
                                    })}
                                </Box>
                            </Box>
                        </Card>
                    </Box>
                ))}
            </Box>
        </Box>
    )
}
